import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function contextMenuChange(payload) {
  // payload: { isShow, type, ... }
  return {
    type: ACTION_TYPES.CONTEXT_MENU_CHANGE_TYPE,
    payload,
  };
}

export function contextBubbleMenuChange(payload) {
  // payload: { isShow, type, ... }
  return {
    type: ACTION_TYPES.CONTEXT_BUBBLE_MENU_CHANGE_TYPE,
    payload,
  };
}

export function contextMenuHide() {
  // payload: { isShow, type, ... }
  return {
    type: ACTION_TYPES.CONTEXT_MENU_HIDE,
    payload: {
      isShow: false,
    },
  };
}

export function closeAllContextMenu() {
  // payload: { isShow, type, ... }
  return {
    type: ACTION_TYPES.CONTEXT_MENU_HIDE,
    payload: {
      isClose: true,
    },
  };
}

export function contextBubbleMenuHide(id) {
  // payload: { isShow, type, ... }
  return {
    type: ACTION_TYPES.CONTEXT_BUBBLE_MENU_HIDE,
    payload: {
      id,
    },
  };
}

export function hideAllBubbleMenu() {
  // payload: { isShow, type, ... }
  return {
    type: ACTION_TYPES.CLOSE_ALL_BUBBLE_MENU,
  };
}

export function checkEligibleIssueMc(id) {
  return {
    types: [
      ACTION_TYPES.CHECK_ELIGIBLE_ISSUE_MC_REQUEST,
      ACTION_TYPES.CHECK_ELIGIBLE_ISSUE_MC_SUCCEED,
      ACTION_TYPES.CHECK_ELIGIBLE_ISSUE_MC_FAILED,
    ],
    promise: client => client.post(`consults/${id}/check-mc-issue-eligible`),
    options: {
      clientName: API_CONSULT,
    },
  };
}
